export default { cache_expired: 30 }
